var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"members"},_vm._l((_vm.members),function(user){return _c('MemberBox',{key:user._id,staticClass:"members__item",attrs:{"data":user}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }